export const MODAL_CLOSE = "MODAL_CLOSE";
export const MODAL_DATA = "MODAL_DATA";
export const HELP_CHANGE = "HELP_CHANGE";
export const ABOUT_CHANGE = "ABOUT_CHANGE";
export const ETL_HELP_CHANGE = "ETL_HELP_CHANGE";

const modalOnOpenAction = (payload) => (
    {
        type: MODAL_DATA,
        modelPayload: payload
    });
const modalOnCloseAction = (payload) => (
    {
        type: MODAL_CLOSE,
        modelPayload: payload
    });

const modalHelpOnChangeAction = (payload) => (
    {
        type: HELP_CHANGE,
        payload: payload
    });
const modalAboutOnChangeAction = (payload) => (
    {
        type: ABOUT_CHANGE,
        payload: payload
    });


const modalETLHelpOnChangeAction = (payload) => (
    {
        type: ETL_HELP_CHANGE,
        payload: payload
    });


export { modalOnOpenAction, modalOnCloseAction, modalHelpOnChangeAction, modalETLHelpOnChangeAction, modalAboutOnChangeAction };